import { networksEnvironments } from 'src/config/networks'
import useActiveOrDefaultChain from '../hooks/web3/useActiveOrDefaultChain'
import useTokenMetadata from './useTokenMetadata'

const useCarbon = () => {
  const chain = useActiveOrDefaultChain()

  const contractAddress = networksEnvironments[chain.id].tokens.carbon ?? ''

  const { data, ...rest } = useTokenMetadata(contractAddress)

  return {
    carbon: data,
    ...rest,
  }
}

export default useCarbon
